import React, { useEffect, useState } from 'react'
import { arrayOf, node, string } from 'prop-types'
import { navigate, Router } from '@reach/router'
import Card from '@taglivros/oef_componentes/build/components/card'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import { ETAPAS_FLUXO_PAGAMENTO, ROUTE_BASEPATH, URLS } from '../../constants'
import { EnderecoProvider } from '../../contexts/EnderecoContext'
import { CartaoCreditoProvider } from '../../contexts/CartaoCreditoContext'
import { useFluxosPagamento } from '../../contexts/FluxosPagamentoContext'
import BreadcrumbCard from '../../components/BreadcrumbCard/BreadcrumbCard'
import LazyComponent from '../../components/LazyComponent/LazyComponent'
import InlineLoader from '../../components/InlineLoader/InlineLoader'
import { isEmptyObject } from '../../utils/helpers/helpers'
import { URLS_APP } from '../../config'

import Plano from './planos/TelaPlano'
import Entrega from './entrega/TelaEntrega'
import Pagamento from './pagamento/TelaPagamento'
import Brindes from './brindes/TelaBrindes'
import Conclusao from './conclusao/TelaConclusao'
import PaginaNaoEncontrada from '../../containers/PaginaNaoEncontrada/PaginaNaoEncontrada'

Plano.etapa = ETAPAS_FLUXO_PAGAMENTO.ROUTE_PLANO
Entrega.etapa = ETAPAS_FLUXO_PAGAMENTO.ROUTE_ENTREGA
Pagamento.etapa = ETAPAS_FLUXO_PAGAMENTO.ROUTE_PAGAMENTO
Brindes.etapa = ETAPAS_FLUXO_PAGAMENTO.ROUTE_BRINDES
Conclusao.etapa = ETAPAS_FLUXO_PAGAMENTO.ROUTE_CONCLUSAO

const getPath = etapa => {
  const paths = {
    [ ETAPAS_FLUXO_PAGAMENTO.ROUTE_PLANO ]: 'selecionar-plano',
    [ ETAPAS_FLUXO_PAGAMENTO.ROUTE_ENTREGA ]: 'selecionar-entrega',
    [ ETAPAS_FLUXO_PAGAMENTO.ROUTE_PAGAMENTO ]: 'selecionar-pagamento',
    [ ETAPAS_FLUXO_PAGAMENTO.ROUTE_BRINDES ]: 'selecionar-brindes',
    [ ETAPAS_FLUXO_PAGAMENTO.ROUTE_CONCLUSAO ]: 'conclusao'
  }

  if ( etapa !== '' && Object.keys( paths ).includes( etapa ) ) {
    return paths[ etapa ]
  }

  return null
}

const getContext = etapa => {
  const provider = {
    [ ETAPAS_FLUXO_PAGAMENTO.ROUTE_ENTREGA ]: EnderecoProvider,
    [ ETAPAS_FLUXO_PAGAMENTO.ROUTE_PAGAMENTO ]: CartaoCreditoProvider
  }

  if ( etapa !== '' && Object.keys( provider ).includes( etapa ) ) {
    return provider[ etapa ]
  }

  return null
}

function FluxosPagamento( { children, visualizacaoEtapas } ) {
  const { etapaAtiva, etapas, setEtapaAtiva, setEtapas, temaFluxo } = useFluxosPagamento()
  const [ primeiraRota, setPrimeiraRota ] = useState( '' )
  const [ breadcrumbEtapas, setBreadcrumbEtapas ] = useState()
  const [ temEtapas, setTemEtapas ] = useState( false )
  const [ etapaAtual, setEtapaAtual ] = useState()
  useEffect(
    () => {
      const etapaAual = Object.values( etapas ).find( etapa => etapa.codigo === etapaAtiva )
      if ( visualizacaoEtapas.length && etapaAtiva === 1 && etapaAual?.autocompleted !== true ) {
        const rotasAtivas = React.Children
          .map(
            children,
            child => child.type.etapa
          )
          .reduce(
            ( acumulador, etapa, index ) => {
              let jump = false
              if ( window.location.href.includes( `#regularizar` ) && etapa === 'ENTREGA' ) {
                jump = true
              }

              const codigoRotaAtiva = index + 1
              return {
                ...acumulador,
                [ etapa ]: {
                  'codigo': codigoRotaAtiva,
                  'completo': false,
                  'identificador': etapa,
                  jump,
                  'rotaAtiva': true,
                  'url': `${getPath( etapa )}`,
                  'visualizacao': visualizacaoEtapas[ index ]
                }
              }
            },
            {}
          )

        setEtapas( rotasAtivas )
      }
    },
    [ etapaAtiva, visualizacaoEtapas ]
  )

  useEffect(
    () => {
      if ( !isEmptyObject( etapas ) ) {
        const compararCodigoEtapas = ( codigo1, codigo2 ) => {
          if ( codigo1.codigo < codigo2.codigo ) {
            return -1
          }
          if ( codigo1.codigo > codigo2.codigo ) {
            return 1
          }
          return 0
        }

        setBreadcrumbEtapas( Object.values( etapas ).sort( compararCodigoEtapas ) )
        setTemEtapas( true )
      }
    },
    [ etapas ]
  )

  useEffect(
    () => {
      if ( !isEmptyObject( etapas ) && etapaAtiva ) {
        const ativo = Object.values( etapas ).find( etapa => etapa.codigo === etapaAtiva )
        setEtapaAtual( ativo )
      }
    },
    [ etapas, etapaAtiva ]
  )

  useEffect(
    () => {
      if ( temEtapas ) {
        const primeiraEtapa = Object.values( etapas ).find( etapa => etapa.codigo === 1 ).url
        setPrimeiraRota( primeiraEtapa )
      }
    },
    [ etapas, temEtapas ]
  )

  const clickBreadcrumb = codigo => {
    if ( temEtapas ) {
      const { url } = Object.values( etapas ).find( etapa => etapa.codigo === codigo )
      setEtapaAtiva( codigo )
      navigate( url )
    }
  }

  const jumpToPagamento = () => {
    const pagamento = Object.values( etapas ).find( etapa => etapa.codigo === 2 )
    const isCuradoria = Boolean( window.location.href.includes( `curadoria` ) )
    setEtapaAtual( pagamento )
    setEtapaAtiva( 2 )
    setEtapas( prevState => {
      const ativo = Object.values( prevState ).find( etapa => etapa.codigo === 1 )
      return {
        ...prevState,
        [ ativo.identificador ]: {
          ...ativo,
          'completo': true
        }
      }
    } )
    navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${
      isCuradoria ? 'curadoria' : 'ineditos'
    }/${URLS.PLANO}/${URLS.RENOVAR_PLANO_PAGAMENTO}` )
  }

  return (
    <>
      { temEtapas ?
        <BreadcrumbCard
          ativo={ etapaAtiva }
          largura="100%"
          margin={ `${StyleGuide.isMobile() ? `20px 0 0` : `30px 0 0`}` }
          onClick={ codigo => clickBreadcrumb( codigo ) }
          passos={ breadcrumbEtapas }
        /> :
        <InlineLoader
          cor={ temaFluxo }
          isCenter
        />}

      <Card
        largura="100%"
        margin="11px 0 0 0"
        padding={ `${StyleGuide.isMobile() ? `20px` : `40px 50px`}` }
      >
        { temEtapas && primeiraRota ?
          <Router>
            <PaginaNaoEncontrada
              default
              isComponente
              pathParaRedirecionamento={ primeiraRota }
            />

            { React.Children.map(
              children,
              child => {
                return React.cloneElement(
                  <LazyComponent />,
                  {
                    'Context': getContext( child.type.etapa ),
                    'Element': child,
                    'currentRoute': etapaAtual.url,
                    etapaAtual,
                    jumpToPagamento,
                    'path': getPath( child.type.etapa ),
                    'primeiraEtapa': primeiraRota
                  }
                )
              }
            ) }
          </Router> :
          <InlineLoader
            cor={ temaFluxo }
            isCenter
          />}
      </Card>
    </>
  )
}

FluxosPagamento.Plano = Plano
FluxosPagamento.Entrega = Entrega
FluxosPagamento.Pagamento = Pagamento
FluxosPagamento.Brindes = Brindes
FluxosPagamento.Conclusao = Conclusao

export default FluxosPagamento

FluxosPagamento.propTypes = {
  'children': node.isRequired,
  'visualizacaoEtapas': arrayOf( string ).isRequired
}

